var maps = [];

$(document).ready(function() {
   AOS.init();

   $('input').iCheck({
     checkboxClass: 'icheckbox_minimal-red',
     radioClass: 'iradio_minimal-red',
     increaseArea: '20%' // optional
   });


   $('.lazy').show().lazy();

   $('.photogalery, .photos').magnificPopup({
       type: 'image',
       delegate: 'a',
       gallery: {
           enabled: true
       }
   });

   $('.iframe-link,.play').magnificPopup({
       type: 'iframe'
   });


  $(".partner-link").click(function(){
      window.open($(this).find("a").attr("href"), "_blank");
      return false;
  });

  $(".product, .new, .product-table").click(function(){
       window.location=$(this).find("a").attr("href");
       return false;
  });

  $("#head .mobileNav").click(function(){
      if($('#head div.menu').hasClass('active')){
          $("#head .mobileNav i").removeClass('icon-cross').addClass('icon-menu');
          $('#head div.menu').removeClass('active');
          $('body').removeClass('locked');
      }else{
          $("#head .mobileNav i").addClass('icon-cross').removeClass('icon-menu');
          $('#head div.menu').addClass('active');
          $('body').addClass('locked');
      }
  });

  $( ".form input,.form textarea" ).focusin(function() {
      $(this).closest('li').addClass('focus');
  });

  $( ".form input,.form textarea" ).focusout(function() {
      val = $(this).val();
      if(val == ''){
          $(this).closest('li').removeClass('focus');
      }
  });
  $('.form button').click(function(){
      $('.form .gform_footer input[type="submit"]').click();
  });

  $('#slider a.modal-btn').click(function(){
      $('#modal').addClass('active');
      if($( window ).height() < $('#modal .container').height()){
          $('body').addClass('locked');
      }
  });

  $('#modal a.close').click(function(){
      $('#modal').removeClass('active');
      $('body').removeClass('locked');
  });

  $('.accordion-item').click(function(){
      if($(this).hasClass('active')){
          $('.accordion-item.active').find('p').slideToggle(100);
          $('.accordion-item.active').removeClass('active');
      }else{
          $('.accordion-item.active').find('p').slideToggle(100);
          $('.accordion-item.active').removeClass('active');
          $(this).addClass('active').find('p').slideToggle(100);
      }
  });



  if($('body').has('.ajaxLoadNews')){
      $.getScript( url+"/scripts/pager.js", function( data, textStatus, jqxhr ) {

      });
  }


  if($('body').find('.gform_confirmation_message').length > 0){
      $('.submit').hide();
      if($('body').find('#modal').length > 0){
          $('#modal').addClass('active');
      }
  }
  if($('body').find('.validation_error').length > 0){
      if($('body').find('#modal').length > 0){
          $('#modal').addClass('active');
      }
      $( ".form #gform_fields_1 li" ).each(function() {
          if($(this).find('input[type="text"]').length > 0){
              val = $(this).find('input[type="text"]').val().length;
              if(val > 0){
                  $(this).addClass('focus');
              }
          }
          if($(this).find('textarea').length > 0){
              val = $(this).find('textarea').val().length;
              if(val > 0){
                  $(this).addClass('focus');
              }
          }
      });
  }

  renderMaps();

  if($( window ).width() > 528){
      str = '<video playsinline="playsinline" autoplay="autoplay" loop="true" muted="muted"><source src="'+$('#slider .video').attr('data-src')+'" type="video/mp4"></video>';
      $('#slider .video').html(str);
  }else{
      $('#slider .video').addClass('isMobile');
  }

});

function renderMaps(){
    if($( "body" ).has( "#map" )){
        $.getScript( url+"/scripts/leaflet.js", function( data, textStatus, jqxhr ) {
            var LeafIcon = L.Icon.extend({
                options: {
                    iconSize:     [35, 35],
                    iconAnchor:   [0, 0]
                }
            });
            var icons  = new LeafIcon({iconUrl: url+'/img/map.svg'});

            zoom = 10;
            if($('#map').attr('data-zoom') != '')  zoom = parseInt($('#map').attr('data-zoom'));
            lat  = parseFloat($('#map').attr('data-lat'));
            lng  = parseFloat($('#map').attr('data-lng'));

        	var mbAttr = '',
        		mbUrl = 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoicm9jZXNtYW5pYyIsImEiOiJjam5hb2NzazQyZWxoM2tydWd0OHN5OThkIn0.2kz8ZH1-HH-TkOh1anDHDA';

        	var grayscale   = L.tileLayer(mbUrl, {id: 'mapbox/light-v9', attribution: mbAttr});

        	var map = L.map('map', {
        		center: [lat, lng],
        		zoom: zoom,
        		layers: [grayscale]
        	});

            L.marker([lat, lng], {icon: icons}).addTo(map);

        });
    }
}
